import React, {Component} from 'react'
import CheckBoxItem from './CheckBoxItem'
import CheckBoxItemOther from './CheckBoxItemOther'
import CheckBoxItemRadio from './CheckBoxItemRadio'

export default class CheckBoxMulti extends Component {
    constructor (props) {
        super(props)

        this.state = {
          questions: [],
          activeItems: [],
        };
    }

    componentDidMount = () => {
        //console.log('didmount: checkbox multi item %o prepop %o', this.props.data, this.props.prepop)
        if(this.props.prepop.hasOwnProperty('id')) {
          this.props.prepop.questions[0].answers.forEach((item) => {
            this.onItemActive(true, item)
          })
        }
    }

    onItemActive = (active, item) => {
      //console.log('onItemActive %o item %o', active, item)
      this.setState({
        activeItems: this.getUpdatedActiveItems(active, item),
      }, () => {
        // This needs to be called after updating all the active items
        this.setState({
          questions: this.getUpdatedQuestions(item),
        }, () => {
          this.dispatch()
        })
      });
    }

    getUpdatedQuestions = item => {
      const updatedFirstQuestion = this.getUpdatedFirstQuestion(item)

      const oldFirstQuestion = this.state.questions.find(question => question.id === updatedFirstQuestion.id)
      if (oldFirstQuestion) {
        // Replace the values of the old "first question" with the updated one.
        // The first question in the question group is the question that we
        // display by default.
        return this.state.questions.map(question => {
          if (question.id === updatedFirstQuestion.id) {
            return updatedFirstQuestion
          }
          return question
        })
      } else {
        // Add the "first question" if we haven't yet.
        return this.state.questions.concat(updatedFirstQuestion)
      }
    }

    getUpdatedFirstQuestion = item => {
      if (item.other) {
        // The "Other" question has a text field that we need to support
        return {
          "id": this.getFirstQuestion().id,
          "answers": this.state.activeItems.map(activeItem => {
            if (activeItem.id === item.id) {
              return Object.assign({}, activeItem, {
                text: item.otherValue,
              })
            }
            return activeItem
          })
        }
      } else {
        return {
          "id": this.getFirstQuestion().id,
          "answers": this.state.activeItems
        }
      }
    }

    dispatch = () => {
      this.props.manageFormData({
        "questionNumber": this.props.questionNumber,
        "valid": true,
        "id": this.props.data.id,
        "questions": this.getQuestionsToDispatch(),
      });
    }

    getQuestionsToDispatch = () => {
      const allowedExtraQuestionIds = this.state.activeItems
        .filter(activeItem => activeItem.linkedQuestionId)
        .map(activeItem => activeItem.linkedQuestionId)

      return this.state.questions.filter(question => {
        if (question.id === this.getFirstQuestion().id) {
          return true
        }

        return allowedExtraQuestionIds.some(questionId => questionId === question.id)
      })
    }

    onRadioChange = data => {
      this.setState({
        questions: this.updateQuestionsWithRadioData(data)
      }, () => {
        this.dispatch()
      })
    }

    updateQuestionsWithRadioData = data => {
      if (data.hasOwnProperty('questions') && data.questions.length > 0) {
        // Update the value of any question that the user has previously set
        const updatedQuestions = this.state.questions.map(question => {
          const updatedQuestion = data.questions.find(updateQuestion => updateQuestion.id === question.id)
          if (updatedQuestion) {
            return updatedQuestion
          }
          return question
        })

        // Add new questions that the user might have answered
        const questionsToAdd = data.questions.filter(potentialQuestionToAdd => {
          return !this.state.questions.some(existingQuestion => existingQuestion.id === potentialQuestionToAdd.id)
        })

        return updatedQuestions.concat(questionsToAdd)
      }

      return this.state.questions
    }

    getFirstQuestion = () => this.props.data.questions[0]

    getUpdatedActiveItems = (active, item) => {
      const activeItemToUpdate = this.state.activeItems.find(activeItem => activeItem.id === item.id)

      if (activeItemToUpdate) {
        if (item.other && active) {
          return this.state.activeItems.map(activeItem => {
            if (activeItem.id === item.id) {
              return item
            }
            return activeItem
          })
        } else {
          return this.state.activeItems.filter(activeItem => activeItem.id !== item.id)
        }
      }

      return this.state.activeItems.concat(item)
    }

    renderOutput = () => {
      return this.getFirstQuestion().answerOptions.map((x, i) => {
        const isAnswerOptionActive = this.state.activeItems.some(activeItem => activeItem.id === x.id)

        if (this.getFirstQuestion().linkedQuestion && x.linkedQuestionId !== null) {
          return (
            <CheckBoxItemRadio
              key={x.id}
              id={x.id}
              data={x}
              questionNumber={this.props.questionNumber}
              onToggle={this.onItemActive}
              active={isAnswerOptionActive}

              radioData={this.props.data}
              radioManageFormData={this.onRadioChange}
              prepop={this.props.prepop}
            />
          )
        }

        if (x.freeTextAllowed === '1') {
          return (
            <CheckBoxItemOther
              key={x.id}
              id={x.id}
              data={x}
              questionNumber={this.props.questionNumber}
              onToggle={this.onItemActive}
              active={isAnswerOptionActive}
            />
          )
        }
        return (
          <CheckBoxItem
            key={x.id}
            id={x.id}
            data={x}
            questionNumber={this.props.questionNumber}
            onToggle={this.onItemActive}
            active={isAnswerOptionActive}
          />
        )
      })
    }

    render() {
    return (
        <div>
            <h3 className='question-title'>{this.getFirstQuestion().text}</h3>
            <div className='custom-checkbox-wrapper multi'>
                <p>(select one or more options)</p>
                <ul>
                    {this.renderOutput()}
                </ul>
            </div>
        </div>
    )
  }
}
